import { FC } from 'react';

import * as St from './LoadingScreen.styles';

export const LoadingScreen: FC = () => (
  <St.Wrapper>
    <St.LoaderContainer>
      <video autoPlay loop muted playsInline>
        <source src="/assets/loader.mp4" type="video/mp4" />
      </video>
    </St.LoaderContainer>
  </St.Wrapper>
);
